import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import {
  TASK_DURATION_UNITS,
  TASK_TYPES,
  TaskDelayUnit,
  TaskTargetType,
  TaskType,
} from '../../../../data/todo/domain/predefined-task';
import { Task } from '../../../../data/todo/domain/task';
import { TaskModalFacade } from './task-modal.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-task-modal',
  templateUrl: './task-modal.component.html',
  styleUrls: ['./task-modal.component.scss'],
  providers: [TaskModalFacade],
})
export class TaskModalComponent {
  readonly TASK_DURATION_UNITS = TASK_DURATION_UNITS;
  readonly TASK_TYPES = TASK_TYPES;
  @Input() task: Task;
  @Output() onValidate = new EventEmitter<Task>();
  @Output() onCancel = new EventEmitter<void>();
  isLoading = false;

  constructor(private bsModalRef: BsModalRef, private facade: TaskModalFacade) {
    // nada
  }

  get withDelay(): boolean {
    return !!this.task.delay;
  }

  set withDelay(value: boolean) {
    if (this.task) {
      if (value) {
        this.task.delay = {
          unit: 'DAY',
          value: 1,
        };
      } else {
        this.task.delay = undefined;
      }
    }
  }

  cancel() {
    this.onCancel.emit();
    this.hideModal();
  }

  async validate() {
    this.isLoading = true;
    this.task = await this.facade.save(this.task);
    this.onValidate.emit(this.task);
    this.isLoading = false;
    this.hideModal();
  }

  enableValidate() {
    if (this.task) {
      if (this.task.delay) {
        return (
          this.task.description &&
          this.task.type &&
          this.task.delay.unit &&
          this.task.delay.value !== undefined
        );
      } else {
        return this.task.description && this.task.type;
      }
    }
    return false;
  }

  getLabelTaskTargetType(type: TaskTargetType) {
    switch (type) {
      case 'NOTHING':
        return 'Tâche libre';
      case 'PATIENT':
        return 'Tâche associée à un patient';
      case 'SELECTION_OF_PATIENTS':
        return 'Tâche associée à plusieurs patients';
    }
  }

  getLabelTaskDelayUnit(unit: TaskDelayUnit) {
    switch (unit) {
      case 'YEAR':
        return 'Année(s)';
      case 'MONTH':
        return 'Mois';
      case 'WEEK':
        return 'Semaine(s)';
      case 'DAY':
        return 'Jour(s)';
      case 'HOUR':
        return 'Heure(s)';
      case 'MINUTE':
        return 'Minute(s)';
    }
  }

  private hideModal() {
    this.bsModalRef.hide();
  }

  changeDelay(value: boolean) {
    this.withDelay = value;
  }

  getClassTaskTypeButton(type: TaskTargetType) {
    if (this.task) {
      if (this.task.targetType === type) {
        return 'btn btn-gradient btn-no-padding';
      }
    }
    return 'btn btn-outline btn-outline-primary btn-no-padding';
  }

  getLabelTaskType(type: TaskType) {
    switch (type) {
      case 'FREE':
        return 'Juste un rappel';
      case 'DOCUMENT':
        return 'Importer ou rédiger un document';
      case 'NOTE':
        return 'Produire une note';
      case 'SURVEY':
        return 'Soumettre un questionnaire';
      case 'CHART':
        return 'Relevé un indicateur biométrique';
      case 'MESSAGE':
        return 'Envoyer un message';
      case 'ENCOURAGEMENT':
        return 'Encourager';
      case 'TRACKER':
        return 'Configurer un tracker';
      case 'APPOINTMENT':
        return 'Prendre un rendez-vous';
      case 'INVOICE':
        return 'Émettre une facture';
      case 'ESTIMATE':
        return 'Proposer un devis';
    }
    return '';
  }
}
